export interface NormalizedServerInput {
  name: string;
  icon: string;
}

export interface ServerInputErrors {
  name?: string;
  icon?: string;
}

const codePointLength = (value: string): number => Array.from(value).length;

export function normalizeServerInput(name: string, icon: string): NormalizedServerInput {
  return { name: name.trim(), icon: icon.trim() };
}

export function validateServerInput(input: NormalizedServerInput): ServerInputErrors {
  const errors: ServerInputErrors = {};
  if (!input.name) errors.name = 'Project name is required.';
  else if (codePointLength(input.name) > 100)
    errors.name = 'Project name must be 100 characters or fewer.';
  if (codePointLength(input.icon) > 500) errors.icon = 'Icon must be 500 characters or fewer.';
  return errors;
}

export function createIdempotencyKey(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
